module.exports = __webpack_public_path__ + "img/old_photo.c48d23f8.jpg";